module.exports = __webpack_public_path__ + "static/media/Leadership and C-Suite Recruitment.606dbad9.png";